import React from "react";
import LabelIconDefault from 'src/assets/icons/L.svg'
export default function Label(props) {
    return (
        <div style={{padding:'2px', cursor:'pointer'}} className="custom_tooltip" >
            <svg xmlns="http://www.w3.org/2000/svg" height="30" width="30" viewBox="0 0 24 24" id="L">
            <path d="M12 23.6C5.6 23.6.4 18.4.4 12S5.6.4 12 .4C18.4.4 23.6 5.6 23.6 12S18.4 23.6 12 23.6zm0-22.2C6.1 1.4 1.4 6.1 1.4 12S6.1 22.6 12 22.6c5.9 0 10.6-4.8 10.6-10.6S17.9 1.4 12 1.4z"class="color000000 svgShape"  fill={props.show?'#F15B24':'#0F4A8A'} stroke={props.show?'#F15B24':'#0F4A8A'} strokeWidth='0.3'></path>
            <path d="M15 16.6h-3.8c-1.2 0-2.2-1-2.2-2.1V7.4h1v7.1c0 .6.5 1.1 1.1 1.1H15v1z" fill={props.show?'#FBD927':'#00BAF2'}  class="color000000 svgShape"   stroke={props.show?'#FBD927':'#00BAF2'}  strokeWidth='0.3'></path></svg>
            <span  className="tooltiptext">Legend</span>
        </div>
    //   <svg xmlns="http://www.w3.org/2000/svg" height="35" width="35" fill="none" viewBox="0 0 512 512" id="l">
    //         <path fill={props.show?'#26A0FC':'#AEB6BF'}  fill-rule="evenodd" d="M255.986 455.276V492C376.192 492 455.304 376.2 455.304 256H492C492 135.8 376.192 56.724 255.986 56.724V20C135.777 20 56.698 135.8 56.698 256H20C20 376.2 135.777 455.276 255.986 455.276ZM311.616 303.24H256.832V165H200V346.248H311.616V303.24Z"
    //             clip-rule="evenodd" class="colorff306d svgShape">
    //         </path>
    //     </svg>

    );
  }
  